module.exports = _.isFinite;


//////////////////
// WEBPACK FOOTER
// external "_.isFinite"
// module id = 1264
// module chunks = full-screen-modals/full-screen-modals mobile-overlay/mobile-overlay mobile/mobile widget/widget